import debug from "src/modules/debug-logger";
import { Type } from "src/modules/media-upload-protobuf";

const Buffer = window.require("buffer")?.Buffer;

const MIN_BUFFER_TO_SEND_LENGTH = 500;
const LENGTH_BUFFER_LENGTH = 4;

export default async function uploadData({ ws, fileHandle, media }) {
  const { writeStream } = media;
  let lengthBuffer = null;
  let bufferToSend = null;
  let bytesRead = 0;
  let fileSize;

  if (writeStream == null) {
    const fsStat = await fileHandle.stat();
    fileSize = fsStat.size;
    debug.activityLog("File size", fileSize);
  }

  function sendDataMessage() {
    const message = Type.Message.create({
      dataMessage: Type.DataMessage.create({ data: bufferToSend })
    });
    ws.send(Type.Message.encode(message).finish());
    bufferToSend = null;
  }

  // checks two things:
  // - if we need to wait for more data to be written
  // - if there is more data to read
  async function canContinueReading(bytesToRead) {
    if (writeStream) {
      if (writeStream.bytesWritten < bytesRead + bytesToRead) {
        if (media.finishedWritting) return false;

        await new Promise((resolve) => {
          setTimeout(async () => {
            await canContinueReading(bytesToRead);
            resolve();
          }, 200);
        });
      }
      return true;
    } else {
      return !(bytesRead === fileSize);
    }
  }

  // reads next 4 bytes which contain audio frame size
  async function readPacketLength() {
    const canContinue = await canContinueReading(LENGTH_BUFFER_LENGTH);
    if (!canContinue) return false;

    lengthBuffer = Buffer.alloc(LENGTH_BUFFER_LENGTH);
    await fileHandle.read(lengthBuffer, 0, LENGTH_BUFFER_LENGTH, bytesRead);
    bytesRead = bytesRead + LENGTH_BUFFER_LENGTH;
    return true;
  }

  // reads next audio frame === number of bytes specified in lengthBuffer
  // writes the data to bufferToSend
  async function readPacketData() {
    const numberOfBytesToRead = lengthBuffer.readInt32BE();
    const canContinue = await canContinueReading(numberOfBytesToRead);
    if (!canContinue) return false;

    const packetDataBuffer = Buffer.alloc(numberOfBytesToRead);

    await fileHandle.read(packetDataBuffer, 0, numberOfBytesToRead, bytesRead);
    bytesRead = bytesRead + numberOfBytesToRead;

    const finalLength = packetDataBuffer.byteLength + LENGTH_BUFFER_LENGTH;

    const packetBuffer = Buffer.concat(
      [lengthBuffer, packetDataBuffer],
      finalLength
    );
    lengthBuffer = null;

    if (bufferToSend == null) {
      bufferToSend = packetBuffer;
    } else {
      bufferToSend = Buffer.concat(
        [bufferToSend, packetBuffer],
        bufferToSend.byteLength + packetBuffer.byteLength
      );
    }

    return true;
  }

  let keepReading = true;

  while (keepReading) {
    if (lengthBuffer) {
      keepReading = await readPacketData();
      if (
        bufferToSend &&
        bufferToSend.byteLength >= MIN_BUFFER_TO_SEND_LENGTH
      ) {
        sendDataMessage();
      }
    } else keepReading = await readPacketLength();
  }

  debug.activityLog(
    `finished reading file ${media.fileName}, bytesRead ${bytesRead}`
  );

  if (bufferToSend) {
    sendDataMessage();
  }
}
